import { ReactComponent as Plus } from "../Icons/Plus.svg";
import { ReactComponent as Sort } from "../Icons/Sort.svg";
import { ReactComponent as SortAscending } from "../Icons/SortAscending.svg";
import { ReactComponent as SortDescending } from "../Icons/SortDescending.svg";
import { ReactComponent as Dashboard } from "../Icons/Dashboard.svg";
import { ReactComponent as Tenant } from "../Icons/Tenant.svg";
import { ReactComponent as Support } from "../Icons/Support.svg";
import { ReactComponent as Filter } from "../Icons/filter.svg";
import { ReactComponent as InfoFill } from "../Icons/InfoFill.svg";
import { ReactComponent as Pdf } from "../Icons/pdf.svg";
import { ReactComponent as Analytics } from "../Icons/Analytics.svg";
import { ReactComponent as CaseIcon } from "../Icons/CaseIcon.svg";
import { ReactComponent as Csv } from "../Icons/Csv.svg";
import { ReactComponent as Alerts } from "../Icons/Alerts.svg";
import { ReactComponent as CaseManagement } from "../Icons/CaseManagement.svg";
import { ReactComponent as List } from "../Icons/List.svg";
import { ReactComponent as Note } from "../Icons/Note.svg";
import { ReactComponent as Search } from "../Icons/Search.svg";
import { ReactComponent as SearchList } from "../Icons/SearchList.svg";
import { ReactComponent as Rating } from "../Icons/rating.svg";
import { ReactComponent as ChevronDown } from "../Icons/ChevronDown.svg";
import { ReactComponent as AiGenerated } from "../Icons/AiGenerated.svg";
import { ReactComponent as ArchivePrediction } from "../Icons/ArchivePrediction.svg";
import { ReactComponent as FirstClass } from "../Icons/FirstClass.svg";
import { ReactComponent as SubsequentClass } from "../Icons/SubsequentClass.svg";
import { ReactComponent as VoiceNote } from "../Icons/VoiceNote.svg";
import { ReactComponent as Schedule } from "../Icons/Schedule.svg";
import { ReactComponent as Calendar } from "../Icons/Calendar.svg";
import { ReactComponent as ChevronCalendarLeft } from "../Icons/ChevronLeft.svg";
import { ReactComponent as ChevronCalendarRight } from "../Icons/ChevronRight.svg";
import { ReactComponent as Xlsx } from "../Icons/XLSX.svg";
import { ReactComponent as Graph } from "../Icons/Graph.svg";
import { ReactComponent as TimeHistory } from "../Icons/TimeHistory.svg";
import { ReactComponent as RoleBasedAnalysis } from "../Icons/RoleBasedAnalysis.svg";
import { ReactComponent as Documentation } from "../Icons/Documentation.svg";
import { ReactComponent as SmsFilled } from "../Icons/SmsFilled.svg";
import { ReactComponent as Coding } from "../Icons/Coding.svg";
import { ReactComponent as IncrementalConsumables } from "../Icons/IncrementalConsumables.svg";
import { ReactComponent as IncrementalService } from "../Icons/IncrementalService.svg";
import { ReactComponent as Timeline1 } from "../Icons/timeline1.svg";
import { ReactComponent as License } from "../Icons/License.svg";
import { ReactComponent as CodeRecommendation } from "../Icons/codeRecommendation.svg";
import { ReactComponent as Doctor } from "../Icons/doctor.svg";
import { ReactComponent as Management } from "../Icons/Management.svg";
import { ReactComponent as ExportIcon } from "../Icons/Export.svg";
import { ReactComponent as DeleteIcon } from "../Icons/Delete.svg";
import { ReactComponent as DownloadTemplate } from "../Icons/DownloadTemplete.svg";
import { ReactComponent as ReUploadTemplate } from "../Icons/ReUpload.svg";
import { ReactComponent as FileTemplate } from "../Icons/FileTemplate.svg";
import { ReactComponent as RoundedPlus} from "../Icons/RoundedPlus.svg"
import { ReactComponent as InfoBlue} from "../Icons/infoBlue.svg"
import { ReactComponent as Prediction} from "../Icons/Prediction.svg"
import { ReactComponent as CaseBoard } from "../Icons/CaseBoard.svg"
import { ReactComponent as Flag } from "../Icons/Flag.svg";
import { ReactComponent as Exclamation } from "../Icons/Exclamation.svg";
import { ReactComponent as CloseIcon } from "../Icons/CloseIcon.svg";
import { ReactComponent as TimestampIssuesIcon } from "../Icons/Timestamp_Issues.svg";
import { ReactComponent as AlertSubmit } from "../Icons/AlertSubmit.svg";
import { ReactComponent as CopilotIconWhite } from "../Icons/CopilotIconWhite.svg";
import { ReactComponent as CopilotIconBlue } from "../Icons/CopilotIconBlue.svg";
import { ReactComponent as UserAvatar } from "../Icons/UserAvatar.svg";
import { ReactComponent as NewSession } from "../Icons/NewSession.svg";
import { ReactComponent as Expand } from "../Icons/Expand.svg";
import { ReactComponent as History } from "../Icons/History.svg";
import { ReactComponent as SendEnabled } from "../Icons/SendEnabled1.svg";
import { ReactComponent as SendDisabled } from "../Icons/SendDisabled.svg";
import { ReactComponent as Email } from "../Icons/Email.svg";
import { ReactComponent as Alert } from "../Icons/Alert.svg";
import { ReactComponent as Warning } from "../Icons/Warning.svg";
import { ReactComponent as Minimise } from "../Icons/Minimise.svg";
import { ReactComponent as Noted } from "../Icons/Noted.svg";
import { ReactComponent as BroadcastIcon } from "../Icons/BroadcastIcon.svg";
import { ReactComponent as SendMessageWhite } from "../Icons/SendMessageWhite.svg";
import { ReactComponent as CheckboxFilled } from "../Icons/CheckboxFilled.svg";
import { ReactComponent as CheckboxEmpty } from "../Icons/CheckboxEmpty.svg";
import { ReactComponent as AlertSuccess } from "../Icons/AlertSuccess.svg";
import { ReactComponent as OperativeNote } from "../Icons/OperativeNote.svg";
import { ReactComponent as OperativeNoteWarning } from "../Icons/OperativeNoteWarning.svg";
import { ReactComponent as NotRecorded } from "../Icons/NotRecorded.svg";
import { ReactComponent as GenerateFailed } from "../Icons/GenerateFailed.svg";
import { ReactComponent as EditOP } from "../Icons/EditOP.svg";
import { ReactComponent as EmptyOP } from "../Icons/EmptyOP.svg";
import { ReactComponent as FilledOP } from "../Icons/FilledOP.svg";
import { ReactComponent as TranscriptOP } from "../Icons/TranscriptOP.svg";
import { ReactComponent as DragFirst } from "../Icons/DragFirst.svg";
import { ReactComponent as DragLast } from "../Icons/DragLast.svg";
import { ReactComponent as DragMid } from "../Icons/DragMid.svg";
import { ReactComponent as MilestoneTrash } from "../Icons/MilestoneTrash.svg";
import { ReactComponent as IconAddAnotherMilestone } from "../Icons/IconAddAnotherMilestone.svg";
import { ReactComponent as IconAddMilestone } from "../Icons/IconAddMilestone.svg";
import { ReactComponent as IconRestore } from "../Icons/IconRestore.svg";
import { ReactComponent as WarningTriangle } from "../Icons/WarningTriangle.svg";
import { ReactComponent as IconMilestone } from "../Icons/IconMilestone.svg";
import { ReactComponent as IconWarning } from "../Icons/IconWarning.svg";
import { ReactComponent as HospitalDetail } from "../Icons/HospitalDetail.svg";
import { ReactComponent as RoomManagement } from "../Icons/RoomManagement.svg";
import { ReactComponent as UserManagement } from "../Icons/UserManagement.svg";
import { ReactComponent as ProcedureManagement } from "../Icons/ProcedureManagement.svg";
import { ReactComponent as EquipmentManagement } from "../Icons/EquipmentManagement.svg";
import { ReactComponent as EmailSent } from "../Icons/EmailSent.svg";
import { ReactComponent as SpecialityManagement } from "../Icons/SpecialityManagement.svg";
import { ReactComponent as GroupManagement } from "../Icons/GroupManagement.svg";
import { ReactComponent as HospitalDetailActive } from "../Icons/HospitalDetailActive.svg";
import { ReactComponent as RoomManagementActive } from "../Icons/RoomManagementActive.svg";
import { ReactComponent as UserManagementActive } from "../Icons/UserManagementActive.svg";
import { ReactComponent as ProcedureManagementActive } from "../Icons/ProcedureManagementActive.svg";
import { ReactComponent as EquipmentManagementActive } from "../Icons/EquipmentManagementActive.svg";
import { ReactComponent as EmailSentActive } from "../Icons/EmailSentActive.svg";
import { ReactComponent as SpecialityManagementActive } from "../Icons/SpecialityManagementActive.svg";
import { ReactComponent as GroupManagementActive } from "../Icons/GroupManagementActive.svg";
import { ReactComponent as IconEdit } from "../Icons/IconEdit.svg";
import { ReactComponent as IconTrash } from "../Icons/IconTrash.svg";
import { ReactComponent as BackButton } from "../Icons/Back-Button.svg";
import { ReactComponent as IconSync } from "../Icons/Sync.svg";

const Icons = {
  Analytics,
  Csv,
  Dashboard,
  Filter,
  InfoFill,
  Pdf,
  Plus,
  Sort,
  SortAscending,
  SortDescending,
  Support,
  Tenant,
  CaseIcon,
  Alerts,
  CaseManagement,
  List,
  Note,
  Search,
  SearchList,
  Rating,
  ChevronDown,
  AiGenerated,
  ArchivePrediction,
  FirstClass,
  SubsequentClass,
  VoiceNote,
  Schedule,
  Calendar,
  ChevronCalendarLeft,
  ChevronCalendarRight,
  Xlsx,
  Graph,
  TimeHistory,
  RoleBasedAnalysis,
  Documentation,
  SmsFilled,
  Coding,
  IncrementalService,
  IncrementalConsumables,
  Timeline1,
  License,
  CodeRecommendation,
  Doctor,
  Management,
  ExportIcon,
  DeleteIcon,
  DownloadTemplate,
  ReUploadTemplate,
  FileTemplate,
  RoundedPlus,
  InfoBlue,
  Prediction,
  CaseBoard,
  Flag,
  Exclamation,
  CloseIcon,
  TimestampIssuesIcon,
  AlertSubmit,
  CopilotIconWhite,
  CopilotIconBlue,
  UserAvatar,
  NewSession,
  Expand,
  History,
  SendEnabled,
  SendDisabled,
  Email,
  Alert,
  Warning,
  Minimise,
  Noted,
  AlertSuccess,
  BroadcastIcon,
  SendMessageWhite,
  CheckboxFilled,
  CheckboxEmpty,
  OperativeNote,
  OperativeNoteWarning,
  NotRecorded,
  GenerateFailed,
  EditOP,
  EmptyOP,
  FilledOP,
  TranscriptOP,
  DragFirst,
  DragLast,
  DragMid,
  MilestoneTrash,
  IconAddAnotherMilestone,
  IconAddMilestone,
  IconRestore,
  WarningTriangle,
  IconMilestone,
  IconWarning,
  HospitalDetail,
  RoomManagement,
  UserManagement,
  ProcedureManagement,
  EquipmentManagement,
  EmailSent,
  SpecialityManagement,
  GroupManagement,
  HospitalDetailActive,
  RoomManagementActive,
  UserManagementActive,
  ProcedureManagementActive,
  EquipmentManagementActive,
  EmailSentActive,
  SpecialityManagementActive,
  GroupManagementActive,
  IconEdit,
  IconTrash,
  BackButton,
  IconSync,
};

export default Icons;
